// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_4V5s3We","h5Text":"_3DqzjM-","h4Text":"_3QQQnNk","h3Text":"_2tgSrEI","srOnly":"_3fGZkty","link":"_1DZ6K8O _4V5s3We","block":"_1wxZhyp","fakeOutsideBlock":"_22UKls1"};